/* eslint-disable prettier/prettier */
export const loadPersonalizedFiles = (personalizedCss: string, personalizedJs: string) => {
    if (personalizedJs) {
        const script = document.createElement('script');
        script.src = personalizedJs;
        script.async = true;
        document.body.appendChild(script);
    }
    
    if (personalizedCss) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = personalizedCss;
        document.head.appendChild(link);
    }
};